import productSelectorThunkActions from "./productSelectorThunk";

function createExtraReducers() {
  return {
    ...getProductListData(),
    ...getProductQuestion(),
    ...postAnswerSubmit(),
  };

  function getProductListData() {
    const { pending, fulfilled, rejected } =
    productSelectorThunkActions.getProductListData;
    return {
      [pending]: (state) => {
        state.productData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.productData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.productData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getProductQuestion() {
    const { pending, fulfilled, rejected } =
    productSelectorThunkActions.getProductQuestion;
    return {
      [pending]: (state) => {
        state.productQuestionData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.productQuestionData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.productQuestionData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function postAnswerSubmit() {
    const { pending, fulfilled, rejected } =
    productSelectorThunkActions.postAnswerSubmit;
    return {
      [pending]: (state) => {
        state.bestAnswerData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.bestAnswerData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.bestAnswerData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
}

const dashboardExtraReducers = createExtraReducers();
export default dashboardExtraReducers;
